import { render } from "./Create.vue?vue&type=template&id=6abfef95&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=6abfef95&scoped=true&lang=css"
import "./Create.vue?vue&type=style&index=1&id=6abfef95&lang=css"

import exportComponent from "/home/dyam/Documentos/Laravel/mistock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abfef95"]])

export default __exports__